import { createContext, FC, useContext, useCallback, useEffect, useState, useReducer, useRef, useMemo } from 'react';
import useFetchAllDimAndAttributeTypes from 'hooks/Filter/useFetchDimAndAttrType';
import useFetchTimePeriodFilter from 'hooks/Filter/useFetchTimePeriod';
import {
    allDimAndAttributeTypeObjectTOListOfAttributeTypeArray,
    applyFilterObjectAdd,
    dimAndAttributeFormater,
    getApplyFilterObject,
    initializeApplyFilter,
    initializeSelectAllValues,
    changePeriodAccordingToScreen,
    initialize,
    getFilteredApplyFilterObject,
    initializeAllSelectedObject,
    createDefaultFilterObject,
} from 'parser/filterParser';
import { UserContext } from './ConfigContext';
import { getConfig, sendNotification } from 'utils/helperMethods';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';
import { callId, createFilterB } from 'components/molecules/Filter/FilterApplyButton';
import { useDownloadAllAttributeNames } from 'hooks/Filter/useDownloadAllAttributeNames';
import { useFetchTimePeriod } from 'hooks/general/useFetchDefinedTimePeriod';
import { useLocation, useNavigate } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import useFetchSinglePreset from 'hooks/Filter/useFetchSinglePreset';
import useGetMaxTimeStamps from 'hooks/general/useGetMaxTimeStamps';

const FilterContextData = createContext<{
    allDimAndAttributeType: any;
    setAllDimAndAttributeType: Function;
    allAttributeNames: any;
    setAllAttributeNames: Function;
    allCheckedAttribute: any;
    setAllCheckedAttribute: Function;
    recentIdFromAttributeSelection: any;
    setRecentIdFromAttributeSelection: Function;
    applyFilterButtonObject: any;
    idForRestOfComponent: any;
    setIdForRestOfComponent: Function;
    previousSelectedAttributesInUI: any;
    setPreviousSelectedAttributesInUI: Function;
    allDimAndAttributeTypeList: any;
    setAllDimAndAttributeTypeList: Function;
    applyFilterObject: any;
    setApplyFilterObject: Function;
    allSelectedValueForAllAttribute: any;
    setAllSelectedValueForAllAttribute: Function;
    timePeriodSelection: any;
    setTimePeriodSelection: Function;
    idForRestOfComponentLoading: boolean;
    setIdForRestOfComponentLoading: Function;
    idForRestOfComponentFilterB: any;
    setIdForRestOfComponentFilterB: Function;
    loadingForAllCheckAttribute: Boolean;
    setLoadingForAllCheckAttribute: Function;
    timePeriodMapping: any;
    timePeriodLoading: boolean;
    recentIdFromAttributeSelectionRef: any;
    timePeriodList: any;
    filterNullError: string;
    setFilterNullError: Function;
    filterBLoading: any;
    setFilterBLoading: Function;
    setTimePeriodList: Function;
    timeSelectionLabel: any;
    setTimeSelectionLabel: Function;
    setLatestUpdatedDate: Function;
    latestDate: null | string;
    visibleDatePicker: boolean;
    setVisibleDatePicker: Function;
    expandFilterBol: boolean;
    setExpandFilterBol: Function;
    presetsFilterObj: any;
    selectedPresetInfoObj: { label: string; value: string; isDefault: boolean };
    setSelectedPresetInfoObj: Function;
    fetchSinglePresetWrapper: Function;
    applyGlobalFilterHandler: Function;
    isGlobalFilterDisabled: boolean;
    disablePresetFilter: boolean;
    setIsGlobalFilterDisabled: Function;
    attributeTypes: any;
    screenFilterConfig: any;
    maxTimeStampData: any;
    maxTimeStampLoading: boolean;
    maxTimeStampError: any;
    screenName: string;
    hideGlobalTimeFilterComponent: boolean; // flag to hide the time period component in the global filter
    setHideGlobalTimeFilterComponent: Function;
    selectedAccount: string;
    setSelectedAccount: Function;
    isProfileSwitching: boolean;
    setIsProfileSwitching: Function;
    showNotification: boolean;
    setShowNotification: Function;
}>({
    allDimAndAttributeType: {},
    setAllDimAndAttributeType: () => {},
    allAttributeNames: {},
    setAllAttributeNames: () => {},
    allCheckedAttribute: {},
    setAllCheckedAttribute: () => {},
    recentIdFromAttributeSelection: {},
    setRecentIdFromAttributeSelection: () => {},
    applyFilterButtonObject: {},
    idForRestOfComponent: {},
    setIdForRestOfComponent: () => {},
    previousSelectedAttributesInUI: {},
    setPreviousSelectedAttributesInUI: () => {},
    allDimAndAttributeTypeList: {},
    setAllDimAndAttributeTypeList: () => {},
    applyFilterObject: {},
    setApplyFilterObject: () => {},
    allSelectedValueForAllAttribute: {},
    setAllSelectedValueForAllAttribute: () => {},
    timePeriodSelection: {},
    setTimePeriodSelection: () => {},
    idForRestOfComponentLoading: false,
    setIdForRestOfComponentLoading: () => {},
    idForRestOfComponentFilterB: {},
    setIdForRestOfComponentFilterB: () => {},
    loadingForAllCheckAttribute: true,
    setLoadingForAllCheckAttribute: () => {},
    timePeriodMapping: null,
    timePeriodLoading: false,
    recentIdFromAttributeSelectionRef: {},
    timePeriodList: [],
    filterNullError: '',
    setFilterNullError: () => {},
    filterBLoading: '',
    setFilterBLoading: () => {},
    setTimePeriodList: () => {},
    timeSelectionLabel: '',
    setTimeSelectionLabel: () => {},
    setLatestUpdatedDate: () => {},
    latestDate: null,
    visibleDatePicker: false,
    setVisibleDatePicker: () => {},
    expandFilterBol: false,
    setExpandFilterBol: () => {},
    presetsFilterObj: {},
    selectedPresetInfoObj: { label: '', value: '', isDefault: false },
    setSelectedPresetInfoObj: () => {},
    fetchSinglePresetWrapper: () => {},
    applyGlobalFilterHandler: () => {},
    isGlobalFilterDisabled: false,
    disablePresetFilter: false,
    setIsGlobalFilterDisabled: () => {},
    attributeTypes: {},
    screenFilterConfig: {},
    maxTimeStampData: undefined,
    maxTimeStampLoading: false,
    maxTimeStampError: null,
    screenName: '',
    hideGlobalTimeFilterComponent: false,
    setHideGlobalTimeFilterComponent: () => {},
    selectedAccount: 'Dave Anderson',
    setSelectedAccount: () => {},
    isProfileSwitching: false,
    setIsProfileSwitching: () => {},
    showNotification: false,
    setShowNotification: () => {},
});

interface props {
    children: React.ReactNode;
}

type screenConfig = {
    screenName: null | string;
    globalTimePeriodKey: null | string;
};

const initialSelectedPresetInfoObj = { label: '', value: '', isDefault: false };

const FilterContext: FC<props> = ({ children }) => {
    let route = useLocation();
    const { appConfig } = useContext(UserContext);
    const globalFilterConfig = getConfig('globalFilter', appConfig);
    const commonConfig = getConfig('commonConfig', appConfig);
    const globalFilterChangingRoutes = globalFilterConfig.globalFilterChangingRoutes;
    const retainFiltersAcrossFeatures = globalFilterConfig?.retainFiltersAcrossFeatures;

    //checking screen name
    const previousRouteName = useRef<any>();

    //check if default preset is fetched
    //will turn true once default preset api call is triggered
    const isDefaultPresetFetched = useRef(false);

    const screenName = route.pathname?.slice(route.pathname?.lastIndexOf('/') + 1);
    const previousScreenName = previousRouteName.current
        ? previousRouteName.current?.slice(previousRouteName.current?.lastIndexOf('/') + 1)
        : '';
    const screenFilterConfig = useMemo(() => {
        return globalFilterChangingRoutes?.[screenName];
    }, [screenName]);
    const currentScreenFeatureName = useMemo(() => {
        return screenFilterConfig?.dimensionListKey || 'default';
    }, [screenFilterConfig]);
    const defaultGlobalFilterFromConfig = screenFilterConfig
        ? screenFilterConfig?.defaultGlobalFilterObj || globalFilterConfig?.PromoScoreCardDefaultObj
        : globalFilterConfig?.PromoScoreCardDefaultObj;

    // state to disable global filter
    const [isGlobalFilterDisabled, setIsGlobalFilterDisabled] = useState(false);
    const [hideGlobalTimeFilterComponent, setHideGlobalTimeFilterComponent] = useState(false);
    const [attributeTypes, setAttributeTypes] = useState({});
    const [selectedAccount, setSelectedAccount] = useState<string>('Dave Anderson');
    const [isProfileSwitching, setIsProfileSwitching] = useState<boolean>(false);
    const [showNotification, setShowNotification] = useState<boolean>(false);

    const [disablePresetFilter, setDisablePresetFilter] = useState(isPresetFilterEnabled());
    const [allDimAndAttributeType, setAllDimAndAttributeType] = useState<any>({ dimentions: [], loading: true });
    const [expandFilterBol, setExpandFilterBol] = useState(true);
    const [allAttributeNames, setAllAttributeNames] = useState<any>({});
    const [allCheckedAttribute, setAllCheckedAttribute] = useState<any>({});
    const [recentIdFromAttributeSelection, setRecentIdFromAttributeSelection] = useState<any>({});
    const recentIdFromAttributeSelectionRef = useRef({});
    const applyFilterButtonObject = useRef({});
    //set default time period list
    const [timePeriodList, setTimePeriodList] = useState<any>([]);
    const [idForRestOfComponent, setIdForRestOfComponent] = useState({
        dim1: { ids: [] },
        dim2: { ids: [] },
    });
    const [idForRestOfComponentLoading, setIdForRestOfComponentLoading] = useState(true);

    //use from config appconfig key - (defaultIdObject) : TODO
    const [previousSelectedAttributesInUI, setPreviousSelectedAttributesInUI] = useState({
        dim1: ['attr', 'attr'],
        dim2: ['attr', 'attr'],
        dim3: ['attr', 'attr'],
        dim4: ['attr', 'attr'],
    });
    const [allDimAndAttributeTypeList, setAllDimAndAttributeTypeList] = useState({ dimentions: [], loading: true });
    const [applyFilterObject, setApplyFilterObject] = useState<any>({});
    const [allSelectedValueForAllAttribute, setAllSelectedValueForAllAttribute] = useState({});
    const [timePeriodSelection, setTimePeriodSelection] = useState<any>();
    const {
        data,
        loading,
        error: fetchAllAttributeTypesError,
        callAllAttributeType,
        setLoading: setFetchAllAttributeTypesLoading,
    } = useFetchAllDimAndAttributeTypes({ currentScreenFeatureName });
    const {
        data: timePeriodData,
        loading: timePeriodLoading,
        error: timePeriodError,
        fetchDefinedTimePeriods,
    } = useFetchTimePeriod();

    const [idForRestOfComponentFilterB, setIdForRestOfComponentFilterB] = useState({
        dim1: { ids: [] },
        dim2: { ids: [] },
    });
    const previousApplyFilterObjectRef = useRef<any>({});
    const [loadingForAllCheckAttribute, setLoadingForAllCheckAttribute] = useState(true);
    const [filterNullError, setFilterNullError] = useState<any>();
    const [filterBLoading, setFilterBLoading] = useState<any>(false);
    const [timeSelectionLabel, setTimeSelectionLabel] = useState('');
    const [latestDate, setLatestDate] = useState<null | string>(null);
    const [visibleDatePicker, setVisibleDatePicker] = useState(false);

    //PRESETS
    const [presetsFilterObj, setPresetsFilterObj] = useState<any>(); //stores the preset filter object (data structure remains same as default filter object)
    const [selectedPresetInfoObj, setSelectedPresetInfoObj] = useState({ ...initialSelectedPresetInfoObj }); //this will have info like preset name, is the preset default(true/false)

    const promoScoreCardConfig = getConfig('promoScoreCard', appConfig);

    const { functionTOCallAllAttributeName, loading: allAttributeLoading } = useDownloadAllAttributeNames({
        setAllCheckedAttribute,
    });
    const {
        data: timePeriodFilter,
        error: timePeriodFilterError,
        loading: timePeriodFilterLoading,
        fetchTimePeriodFilter,
    } = useFetchTimePeriodFilter();
    let {
        data: maxTimeStampData,
        loading: maxTimeStampLoading,
        getMaxTimeStampsCall,
        error: maxTimeStampError,
    } = useGetMaxTimeStamps();

    const {
        loading: singlePresetFetchLoading,
        fetchSinglePreset,
        setLoading: setSinglePresetLoading,
    } = useFetchSinglePreset({
        onComplete: onPresetFetchComplete,
        onError: onPresetFetchError,
    });

    const { applyFilterMutate, loading: applyFilterLoad } = useApplyFilterMutation({
        onComplete: onApplyFilterComplete,
    });
    const { applyFilterMutate: applyFilterForFilterB, loading: applyFilterBLoad } = useApplyFilterMutation({
        onComplete: onApplyFilterCompleteFilterB,
    });
    function onApplyFilterCompleteFilterB(payload: any) {
        setIdForRestOfComponentFilterB(payload);
    }

    function isPresetFilterEnabled() {
        if (globalFilterConfig.presetConfig?.disablePresetFilter) return false;
        return Boolean(
            globalFilterConfig.presetConfig?.presetEnabledRoutes &&
                ('all' in globalFilterConfig.presetConfig?.presetEnabledRoutes ||
                    screenName in globalFilterConfig.presetConfig?.presetEnabledRoutes),
        );
    }

    useEffect(() => {
        setIdForRestOfComponentLoading(applyFilterLoad);
        setFilterBLoading(applyFilterLoad);
    }, [applyFilterLoad]);

    useEffect(() => {
        setLoadingForAllCheckAttribute(loading || timePeriodFilterLoading);
    }, [loading, timePeriodFilterLoading]);

    function setLatestUpdatedDate(dateString: string) {
        setLatestDate(dateString);
    }

    function onApplyFilterComplete(payload: any) {
        setIdForRestOfComponent(payload);
        let rbacDefault = JSON.parse(localStorage.getItem('userAccessScope') || '')?.data_metrics?.data_types;

        functionTOCallAllAttributeName(
            allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType),
            payload,
            { ...presetsFilterObj, ...rbacDefault },
        );
        //check if preset is available
        // if (!selectedPresetInfoObj?.value) {
        //     functionTOCallAllAttributeName(
        //         allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType),
        //         payload,
        //         { ...presetsFilterObj, ...rbacDefault },
        //     );
        // } else allDimAndAttributeTypeObjectTOListOfAttributeTypeArray(allDimAndAttributeType);
        //COMMENTED FOR PRESETS
        // setAllSelectedValueForAllAttribute((oldData: any) => {
        //     for (let attrType in oldData) {
        //         if (attrType in globalFilterConfig.promoScoreCardDefault) {
        //             oldData[attrType] = false;
        //         } else {
        //             oldData[attrType] = false;
        //         }
        //     }
        //     return oldData;
        // });
        setAllDimAndAttributeTypeList(allDimAndAttributeType);
        setSinglePresetLoading(false);
        setRecentIdFromAttributeSelection(() => ({
            attr: payload,
        }));
        recentIdFromAttributeSelectionRef.current = {
            attr: payload,
        };
    }

    useEffect(() => {
        //to call all dim and attribute
        const tempObj: screenConfig = {
            screenName: screenFilterConfig?.dimensionListKey || 'default',
            globalTimePeriodKey: screenFilterConfig?.getGlobalTimestampsKey || 'default',
        };
        resetAndUpdateGlobalFilter(tempObj, true);
        //callAllAttributeType();
    }, []);

    //reset global filter
    useEffect(() => {
        //check if preset filter is enabled for current route
        const isPresetEnabledForCurrentRoute = isPresetFilterEnabled();
        if (disablePresetFilter && isPresetEnabledForCurrentRoute) isDefaultPresetFetched.current = false; //reset the preset
        setDisablePresetFilter(!isPresetEnabledForCurrentRoute);

        //retain filters when moving across different routes
        if (retainFiltersAcrossFeatures) {
            previousApplyFilterObjectRef.current = { ...(applyFilterObject || {}) };
        }

        //check if routes are in same filter group ,
        //if routes are in same group, then dont reset global filter
        const areRoutesInSameGroup =
            globalFilterChangingRoutes?.[previousScreenName]?.groupKey &&
            globalFilterChangingRoutes?.[previousScreenName]?.groupKey ===
                globalFilterChangingRoutes?.[screenName]?.groupKey; //if routes are in same group, then dont reset global filter
        //if current route is pvm or depletion and user navigating to other routes, then reset global filter to default and vice versa
        if (
            globalFilterChangingRoutes &&
            !areRoutesInSameGroup &&
            (screenName in globalFilterChangingRoutes || previousScreenName in globalFilterChangingRoutes)
        ) {
            const tempObj: screenConfig = {
                screenName: screenFilterConfig?.dimensionListKey || 'default',
                globalTimePeriodKey: screenFilterConfig?.getGlobalTimestampsKey || 'default',
            };
            resetAndUpdateGlobalFilter(tempObj, false);
        }
        previousRouteName.current = route.pathname;
    }, [route.pathname]);

    //wrapper function to reset and update global filter
    function resetAndUpdateGlobalFilter(screenConfig: screenConfig, isInitialCall: boolean = false) {
        const { screenName, globalTimePeriodKey } = screenConfig;
        //reset necessary state to default
        setAttributeTypes({});
        setAllDimAndAttributeTypeList({ dimentions: [], loading: true });
        setAllDimAndAttributeType({ dimentions: [], loading: true });
        //preset
        setPresetsFilterObj(undefined);
        setSelectedPresetInfoObj({ ...initialSelectedPresetInfoObj });

        // get dimension list
        callAllAttributeType({ featureName: screenName });

        //get global timestamps
        fetchTimePeriodFilter({ featureName: globalTimePeriodKey });

        //only call getmaxtimestamps on initial load
        if (isInitialCall) {
            getMaxTimeStampsCall({
                // read this from config
                variables: { frequency: commonConfig.frequency, featureName: screenName },
            });
        }
    }
    // console.log(allDimAndAttributeType, 'logging dim');
    //set attribute types dynamically once data is loaded
    useEffect(() => {
        if (data && 'dimention' in data && Object.keys(data)?.length > data.dimention?.length) {
            setFetchAllAttributeTypesLoading(false);
            const { dimAndAttribute, attributeTypesObj } = dimAndAttributeFormater(data);
            setAllDimAndAttributeType({
                dimentions: dimAndAttribute,
                loading: false,
            });
            setAttributeTypes(attributeTypesObj);
        }
    }, [data]);

    //change loading state in case error is thrown
    useEffect(() => {
        if (fetchAllAttributeTypesError && !loading) {
            setAllDimAndAttributeType({
                ...allDimAndAttributeType,
                loading: false,
            });
        }
    }, [fetchAllAttributeTypesError]);

    //initialize all states once attributes types are loaded
    useEffect(() => {
        if (attributeTypes && Object.keys(attributeTypes)?.length > 0) {
            setAllCheckedAttribute(initializeAllSelectedObject(attributeTypes));
            setApplyFilterObject(initializeApplyFilter(attributeTypes));
            setAllSelectedValueForAllAttribute(initializeSelectAllValues(attributeTypes));
        }
    }, [attributeTypes]);

    const dimList = attributeTypes ? Object.keys(attributeTypes) : [];

    const screenHistory = useRef<any[]>([]);

    //check if different time period exists for different screens
    useEffect(() => {
        if (timePeriodFilter.length > 0) {
            const previousScreenName = screenHistory.current?.[screenHistory.current.length - 1] || '';
            const secondPreviousScreenName = screenHistory.current?.[screenHistory.current.length - 2] || '';
            const timePeriodCurrentMapping = globalFilterConfig?.timePeriodScreenMapping?.[screenName];
            const timePeriodPreviousMapping = globalFilterConfig?.timePeriodScreenMapping?.[previousScreenName];
            const timePeriodSecondPreviousMapping =
                globalFilterConfig?.timePeriodScreenMapping?.[secondPreviousScreenName];
            screenHistory.current.push(screenName);
            if (
                timePeriodCurrentMapping ||
                timePeriodPreviousMapping ||
                timePeriodSecondPreviousMapping ||
                !timePeriodList?.length
            ) {
                const periodList = changePeriodAccordingToScreen(screenName, timePeriodFilter, globalFilterConfig);
                setTimePeriodList(periodList);
                //updatePeriodList();
                checkIfTimePeriodExistsAndUpdate(timeSelectionLabel, periodList);
            }
        }
    }, [timePeriodFilter, route.pathname]);

    //on changing route, check if selected time period filter is present in time period list,
    // if not set 1st item from time period list as time period filter
    function checkIfTimePeriodExistsAndUpdate(timeSelectionLabel: string, periodList: any[]) {
        const defaultSelectedTimePeriod = periodList?.filter(
            (time: any) => time.timePeriod?.toLowerCase() === String(timeSelectionLabel)?.toLowerCase(),
        )[0];
        //if time period not present in list, then update time period by 1st item from list
        if (!defaultSelectedTimePeriod) {
            setTimePeriodSelection(
                JSON.stringify({
                    start_timestamp: periodList?.[0]?.startTimestamp,
                    end_timestamp: periodList?.[0]?.endTimestamp,
                }),
            );
            setTimeSelectionLabel(periodList?.[0]?.timePeriod);
        }
    }

    const updatePeriodList = () => {
        const periodList = changePeriodAccordingToScreen(screenName, timePeriodFilter, globalFilterConfig);
        const defaultSelectedTimePeriod =
            periodList?.filter(
                (time: any) => time.timePeriod === String(globalFilterConfig.defaultPeriod)?.toLowerCase(),
            )[0] || periodList?.[0];
        // apply default time period
        if (defaultSelectedTimePeriod) {
            setTimePeriodSelection(
                JSON.stringify({
                    start_timestamp: defaultSelectedTimePeriod.startTimestamp,
                    end_timestamp: defaultSelectedTimePeriod.endTimestamp,
                }),
            );
            setTimeSelectionLabel(defaultSelectedTimePeriod.timePeriod?.toUpperCase());
        }
    };

    //parse time period from presets
    function parseTimePeriod(timePeriodObj: any) {
        //getting current period list from config
        const periodList = changePeriodAccordingToScreen(screenName, timePeriodFilter, globalFilterConfig);
        let periodObj = periodList?.filter(
            (time: any) => time.timePeriod?.toLowerCase() === timePeriodObj?.timeSelectionLabel?.toLowerCase(),
        )[0];
        if (periodObj?.timePeriod?.toLowerCase() === 'custom date') {
            const parsedDatObj = JSON.parse(timePeriodObj?.timePeriodSelection);
            periodObj.startTimestamp = parsedDatObj?.start_timestamp;
            periodObj.endTimestamp = parsedDatObj?.end_timestamp;
        }
        //if preset time period exists in period list, use that else use first item from period list
        const tempTimeSelectionLabel = periodObj ? periodObj?.timePeriod : periodList?.[0]?.timePeriod;
        const tempTimePeriodSelection = JSON.stringify({
            start_timestamp: periodObj ? periodObj?.startTimestamp : periodList?.[0]?.startTimestamp,
            end_timestamp: periodObj ? periodObj?.endTimestamp : periodList?.[0]?.endTimestamp,
        });
        setVisibleDatePicker(timePeriodObj?.timeSelectionLabel?.toLowerCase() === 'custom date');
        setTimePeriodSelection(tempTimePeriodSelection);
        setTimeSelectionLabel(tempTimeSelectionLabel);
    }

    //wrapper function for fetching single preset
    function fetchSinglePresetWrapper(variables: any = {}) {
        const userEmail = localStorage.getItem('email');
        if (!userEmail)
            return sendNotification('error', 'Please login to the application again to perform this action.');
        const disablePresetFilter = !isPresetFilterEnabled();
        const skipPresetCall = Object.keys(variables).length === 0 && isDefaultPresetFetched.current;

        //if preset filter is disabled or screen level config is present then load with default filter
        //if this is true, then default preset is already fetched
        //dont fetch preset again if default preset call is already triggered before irrespective of its status
        if (disablePresetFilter || skipPresetCall) {
            onPresetFetchError();
            return;
        }

        if (!isDefaultPresetFetched.current) isDefaultPresetFetched.current = true;
        fetchSinglePreset({
            variables: {
                userEmail,
                defaultFlag: true,
                presetFilterName: '',
                ...variables,
            },
        });
    }

    //called when preset fetch throws an error
    //set all global filter variables to default
    function onPresetFetchError() {
        //if retain filters is true, then consider previous apply filter object
        const defaultFilter =
            Object.keys(previousApplyFilterObjectRef.current).length > 0
                ? previousApplyFilterObjectRef.current
                : defaultGlobalFilterFromConfig;
        setPresetsFilterObj({ ...defaultFilter });
        setAllCheckedAttribute(initializeAllSelectedObject(attributeTypes));
        setAllSelectedValueForAllAttribute((oldData: any) => {
            for (let attrType in oldData) {
                oldData[attrType] = false;
            }
            return oldData;
        });
        setApplyFilterObject(initializeApplyFilter(attributeTypes));
        //for time period
        updatePeriodList();

        setSinglePresetLoading(false);
        setSelectedPresetInfoObj({ ...initialSelectedPresetInfoObj });
    }

    //called when single preset fetch is complete
    function onPresetFetchComplete(stringifiedPresentFilter: any) {
        const { filterObj, timePeriodFilterObj } = JSON.parse(stringifiedPresentFilter?.presetFilter);
        try {
            //for global filter except time period
            setApplyFilterObject(filterObj?.applyFilterObject);
            setAllCheckedAttribute(filterObj?.allCheckedAttribute);
            setAllSelectedValueForAllAttribute(filterObj?.allSelectedValueForAllAttribute);
            setPresetsFilterObj(createDefaultFilterObject(filterObj?.applyFilterObject));

            //for time period
            parseTimePeriod(timePeriodFilterObj);

            //preset name and is default
            setSelectedPresetInfoObj({
                label: stringifiedPresentFilter?.defaultFlag
                    ? `${stringifiedPresentFilter?.presetFilterName} (Default)`
                    : stringifiedPresentFilter?.presetFilterName,
                value: stringifiedPresentFilter?.presetFilterName,
                isDefault: stringifiedPresentFilter?.defaultFlag,
            });
            sendNotification('success', 'Preset loaded successfully.');
        } catch (error) {
            onPresetFetchError();
            console.log(error, 'logging error');
        }
    }

    // apply global filters, except time period
    function applyGlobalFilterHandler(stringifiedPresentFilter: any) {
        const { filterObj } = JSON.parse(stringifiedPresentFilter);
        try {
            setApplyFilterObject(filterObj?.applyFilterObject);
            setAllCheckedAttribute(filterObj?.allCheckedAttribute);
            setAllSelectedValueForAllAttribute(filterObj?.allSelectedValueForAllAttribute);
            setPresetsFilterObj(createDefaultFilterObject(filterObj?.applyFilterObject));
        } catch (error) {
            console.log(error, 'logging error');
        }
    }

    useEffect(() => {
        if (timePeriodFilter?.length > 0 && attributeTypes && Object.keys(attributeTypes).length > 0) {
            fetchSinglePresetWrapper({});
        }
    }, [timePeriodFilter, attributeTypes]);

    //Dim and Attribute Type
    useEffect(() => {
        if (!allDimAndAttributeType.loading && allDimAndAttributeType.dimentions && presetsFilterObj) {
            initialize(
                applyFilterObject,
                presetsFilterObj,
                applyFilterObjectAdd,
                setApplyFilterObject,
                getApplyFilterObject,
                callId,
                applyFilterMutate,
                promoScoreCardConfig,
                getFilteredApplyFilterObject,
                createFilterB,
                applyFilterForFilterB,
                //  screenName === 'promo-score-card',
                true,
            );
        }
    }, [allDimAndAttributeType, presetsFilterObj]);

    const memoisedDimAndAttributeList = useMemo(() => {
        return {
            dimentions: allDimAndAttributeTypeList.dimentions,
            loading: allDimAndAttributeTypeList.loading || singlePresetFetchLoading,
        };
    }, [allDimAndAttributeTypeList, singlePresetFetchLoading]);

    const state = {
        allDimAndAttributeType,
        setAllDimAndAttributeType,
        allAttributeNames,
        setAllAttributeNames,
        allCheckedAttribute,
        setAllCheckedAttribute,
        recentIdFromAttributeSelection,
        setRecentIdFromAttributeSelection,
        applyFilterButtonObject,
        idForRestOfComponent,
        setIdForRestOfComponent,
        previousSelectedAttributesInUI,
        setPreviousSelectedAttributesInUI,
        allDimAndAttributeTypeList: memoisedDimAndAttributeList,
        setAllDimAndAttributeTypeList,
        applyFilterObject,
        setApplyFilterObject,
        allSelectedValueForAllAttribute,
        setAllSelectedValueForAllAttribute,
        timePeriodSelection,
        setTimePeriodSelection,
        idForRestOfComponentLoading,
        setIdForRestOfComponentLoading,
        idForRestOfComponentFilterB,
        setIdForRestOfComponentFilterB,
        loadingForAllCheckAttribute,
        setLoadingForAllCheckAttribute,
        timePeriodMapping: timePeriodData,
        timePeriodLoading: timePeriodFilterLoading,
        recentIdFromAttributeSelectionRef,
        timePeriodList,
        filterNullError,
        setFilterNullError,
        filterBLoading,
        setFilterBLoading,
        setTimePeriodList,
        timeSelectionLabel,
        setTimeSelectionLabel,
        setLatestUpdatedDate,
        latestDate,
        visibleDatePicker,
        setVisibleDatePicker,
        expandFilterBol,
        setExpandFilterBol,
        presetsFilterObj,
        selectedPresetInfoObj,
        setSelectedPresetInfoObj,
        fetchSinglePresetWrapper,
        applyGlobalFilterHandler,
        isGlobalFilterDisabled,
        setIsGlobalFilterDisabled,
        attributeTypes,
        screenFilterConfig,
        maxTimeStampData,
        maxTimeStampLoading,
        maxTimeStampError,
        screenName,
        hideGlobalTimeFilterComponent,
        setHideGlobalTimeFilterComponent,
        disablePresetFilter,
        selectedAccount,
        setSelectedAccount,
        isProfileSwitching,
        setIsProfileSwitching,
        showNotification,
        setShowNotification,
    };
    return <FilterContextData.Provider value={state}>{children}</FilterContextData.Provider>;
};
export { FilterContext, FilterContextData };
